import { useSearchParams } from 'react-router-dom'
import { CANCELLATION_FLOW_STEP } from './lib/helpers'
import { Button, Separator } from '@/ui'

export const UserCancellationFlowFooter = ({
  stayLabel,
  continueLabel,
  disabled,
  isLoading,
  goToNextStep,
}: {
  stayLabel: string
  continueLabel?: string
  disabled?: boolean
  isLoading?: boolean
  goToNextStep: () => void
}) => {
  const [_, setSearchParams] = useSearchParams()

  const handleStayClick = () => {
    setSearchParams({
      step: CANCELLATION_FLOW_STEP.cancellationPrevented,
    })
  }

  return (
    <div className="space-y-4">
      <Separator />

      <div className="flex justify-end">
        <Button
          onClick={() => goToNextStep()}
          variant="link"
          className="pr-10"
          disabled={disabled}
          loading={isLoading}
        >
          {continueLabel ?? 'Continue to Cancel'}
        </Button>

        <Button onClick={handleStayClick}>{stayLabel}</Button>
      </div>
    </div>
  )
}
